module.exports = __webpack_public_path__ + "fonts/Arimo-700-cyrillic26.d60385d.woff2";